import React, { useEffect, useState, FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/root";
import { addProperty, getPropertySelectionList, resetAddProperty } from "../../redux/actions/propertySelectionList/propertySelectionList";
import AmpButton from "../common/AmpButton/AmpButton";
import { setToastNotification } from "../../redux/actions/toastNotification/toastNotification";
import { changeModalState, changeModalContent, changeIsCloseable } from "../../redux/actions/modal/modal";
import RollAccessKey from "../common/RollAccessKey/RollAccessKey";

import "./AddProperty.css"
import AmpFormError from "../common/AmpFormError/AmpFormError";
import { AddPropertyState } from "../../redux/reducers/getPropertySelectionListReducer/addPropertyReducer";
import AddPropertyEnotif from "../account/AddPropertyEnotifi/AddPropertyEnotif";
import { ENOTIFICATION_SUBMIT } from "../../redux/actionTypes/actionsTypes";

export default function AddProperty() {

    const { t } = useTranslation(['propertySelectionList', 'login']);

    const [roll, setRoll] = useState("");
    const [errorMsg, setMsg] = useState("");

    const addPropertyState: AddPropertyState = useSelector((state: RootState) => state.propertyListReducer.addProperty as AddPropertyState);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!addPropertyState.loading && addPropertyState.status) {
            if (addPropertyState.status === 200 && addPropertyState.success) {
                dispatch(setToastNotification(t("add-property-modal.toast-success-1") as string + roll + t("add-property-modal.toast-success-2") as string, "success"));
                const userProfileId = window.localStorage.getItem("userProfileId");
                userProfileId && dispatch(getPropertySelectionList(userProfileId));
                dispatch(resetAddProperty());
                if (addPropertyState.enotif_addable) {
                    // Begin Enotification Preference Flow
                    // Show Enotification Modal
                    dispatch({type: ENOTIFICATION_SUBMIT.RESET})
                    dispatch(changeModalContent(
                        <AddPropertyEnotif roll={roll} />,
                        t("4-enotif-heading", {ns: "login"}),
                        t("4-enotif-heading", {ns: "login"}),
                    ));
                    dispatch(changeIsCloseable(false));
                } else {
                    dispatch(changeModalState("modal-fade-out"));
                }
            } else if (addPropertyState.status === 500 || addPropertyState.success === false) {
                let message = t("add-property-modal.toast-fail") as string;
                if (addPropertyState.message) {
                    if (addPropertyState.message as string === "Key does not match records") {
                        message = t("add-property-modal.toast-fail-not-match") as string;
                    } else if (addPropertyState.message as string === "Roll number not found") {
                        message = t("add-property-modal.toast-fail-not-found") as string;
                    } else if (addPropertyState.message as string === "Roll Number Is Shared") {
                        message = t('add-property-modal.maximum-link-error') as string;
                    } else if (addPropertyState.message as string === "Roll Number Already Exists In Your Account") {
                        message = t('add-property-modal.already-have') as string;
                    } else {
                        message = t("add-property-modal.toast-fail-not-found");
                    }
                }
                if (message !== "") {
                    dispatch(setToastNotification(message, "error"));
                    setMsg(message);
                }
                dispatch(resetAddProperty());
            }
        }
    }, [addPropertyState, dispatch, t, roll]);

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        setMsg("");
        dispatch(resetAddProperty());
        dispatch(setToastNotification("", "default"))

        const data: FormData = new FormData(e.target as HTMLFormElement);
        const values = Object.fromEntries(data.entries()) as Record<string, string>;

        const rollParts = Object.keys(values)
            .filter((key) => key.includes("roll_part"))
            .reduce((cur, key) => { return Object.assign(cur, { [key]: values[key] }) }, {});

        let rollNumber = "";
        Object.keys(rollParts).forEach(
            (value) => {
                rollNumber += values[value];
            }
        )
        setRoll(rollNumber);
        const payload = {
            "roll": rollNumber,
            "access_key": values["access-key"]
        }
        let hasError = false;

        if (values["access-key"] === "") {
            hasError = true;
            setMsg(t('access-key-error', { ns: "login" }) as string)
        }

        if (rollNumber.replace(/[^0-9]+/g, '').length !== 19) {
            hasError = true;
            setMsg(t('roll-num-error', { ns: "login" }) as string)
        }

        if (!hasError) {
            const userProfileId = window.localStorage.getItem("userProfileId");
            userProfileId && dispatch(addProperty(userProfileId, payload));
        }
    }

    return (
        <div className="add-property-container" key={addPropertyState.keyId as number}>
            <form onSubmit={(e) => { onSubmit(e) }}>
                <RollAccessKey showTooltip={true} />
                <AmpFormError errorMessage={errorMsg} error={errorMsg !== ""} />
                <AmpButton onClick={() => null} type="submit" text={t("add-property-modal.add-button") as string} disabled={addPropertyState.loading as boolean} />
            </form>
        </div>
    )
}
